export default __webpack_public_path__ + "static/media/guild.2e1b2f0f.jpg";